<template>
    <form @submit.prevent="reset" class="mt-8">
        <input-group name="email" v-model="form.email" type="email" icon="mail" :label="$t('general.email')"
                     autocomplete="username" :form="form"/>

        <default-button type="submit" color="green" icon="lock-closed" :loading="form.processing"
                        class="mt-6" block>
            {{ $t('auth.reset_password') }}
        </default-button>

        <div class="mt-6 flex items-center justify-end">
            <div class="text-sm leading-5">
                <span
                    class="font-medium text-green-600 hover:text-green-500 focus:outline-none focus:underline transition cursor-pointer"
                    @click="$emit('change-mode', 'login')">
                    {{ $t('auth.back_to_login') }}
                </span>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            form: this.$inertia.form({
                email: '',
            }),
        };
    },

    methods: {
        reset() {
            this.form.post(this.route('password.email'), {
                onSuccess: () => this.$emit('change-mode', 'login'),
            });
        },
    },
};
</script>
